(function () {
	function swiperInit() {
		subSliderInit(true);
		sliderInit(true);

		if (typeof initProductPage === "function") {
			document.querySelectorAll('section[id^="MainProduct-"]').forEach((section) => {
				initProductPage(section);
			});
		}
	}

	document.addEventListener('shopify:section:load', function (e) {
		swiperInit();
	});

	swiperInit();
})();
